import { useEffect, useState } from "react";
import { useApp } from "../components/appState";
import { Avatar } from "../components/Avatar";
import { Icon } from "../components/Icons";
import { plural } from "../lib/format";
import { addPerson, fetchPeople, visiblePeople } from "../lib/peoplePage";
import type { Person } from "../lib/types";

export default function People() {
  const { open, version, changed, email, signOut } = useApp();
  const [people, setPeople] = useState<Person[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [q, setQ] = useState("");
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState({ name: "", email: "" });

  useEffect(() => {
    let live = true;
    fetchPeople()
      .then((p) => live && setPeople(p))
      .catch((e: Error) => live && setError(e.message));
    return () => {
      live = false;
    };
  }, [version]);

  const add = () =>
    addPerson(draft.name, draft.email).then(() => {
      setDraft({ name: "", email: "" });
      setAdding(false);
      changed("Added");
    }, (e: Error) => setError(e.message));

  return (
    <>
      <div className="ph">
        <h1>People</h1>
        <span className="meta">who you went with</span>
      </div>
      <div className="gpanel">
        <div>
          Google Contacts connect, photo sync and import are not in this app yet. Until the switch-over they stay on the
          People page at shows.mattfinkel.com.
        </div>
      </div>
      <label className="search">
        <Icon name="search" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search people" aria-label="Search people" />
      </label>
      {error && <p className="error">{error}</p>}
      {!people && !error && <p className="loading">Loading…</p>}
      <div>
        {visiblePeople(people ?? [], q).map((p) => (
          <button type="button" key={p.id} className="prow" onClick={() => open("person", p.id)}>
            <Avatar person={p} />
            <span>
              <span className="pn">{p.name}</span>
              <br />
              <span className="ps">
                {plural(p.shows, "show")} together{p.hidden ? " · hidden on shared links" : ""}
              </span>
            </span>
            <span className="faint">›</span>
          </button>
        ))}
      </div>
      {adding ? (
        <div className="form">
          <div className="two">
            <label className="f">
              <span>Name</span>
              <input value={draft.name} onChange={(e) => setDraft({ ...draft, name: e.target.value })} />
            </label>
            <label className="f">
              <span>Email</span>
              <input value={draft.email} placeholder="optional" onChange={(e) => setDraft({ ...draft, email: e.target.value })} />
            </label>
          </div>
          <div className="sheet-acts">
            <button type="button" className="btn" disabled={!draft.name.trim()} onClick={add}>
              Add person
            </button>
            <button type="button" className="btn ghost" onClick={() => setAdding(false)}>
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <button type="button" className="btn ghost" style={{ justifySelf: "start" }} onClick={() => setAdding(true)}>
          + Add a person
        </button>
      )}
      <p className="faint" style={{ margin: 0, fontSize: 12 }}>
        Signed in as <span className="mono">{email ?? "—"}</span> ·{" "}
        <button type="button" className="link" onClick={signOut}>
          Sign out
        </button>
      </p>
    </>
  );
}
